import React, { useState } from "react";
import svgData from "../../constants/utilities/svgData";
import { validateInputSecurity } from "../../constants/helpers/helperFunctions";

export default function LoginInputs({ icon, value, disabled, placeholder, type = "text", errorMessage, label, onChange, register, style, eyeIcon, setShowPassword, showPassword }) {
  const [localError, setLocalError] = useState("");

  const handleChange = (e) => {
    const val = e.target.value;
    const errorMsg = validateInputSecurity(val);
    setLocalError(errorMsg);

    if (e.target.setCustomValidity) {
      e.target.setCustomValidity(errorMsg);
    }

    if (onChange) {
      onChange(e);
    }
    if (register && register.onChange) {
      register.onChange(e);
    }
  };

  return (
    <div>
      {label && <label>{label}</label>}
      <div className="loginInput">
        {icon}
        <input
          placeholder={placeholder}
          type={type}
          value={value}
          disabled={disabled}
          {...register}
          onChange={handleChange}
          style={style}
        />
        {eyeIcon && (
          <div className="cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
            {eyeIcon}
          </div>
        )}
      </div>
      {(localError || errorMessage) && (
        <p className="error-message text-danger text-start mb-0">
          {localError || errorMessage?.message || errorMessage}
        </p>
      )}
    </div>
  );
}
